
import * as List from "list.js";

const Staff = (target) => {

  const el = {
    boxes: target.querySelectorAll(".staff-box"),
    links: target.querySelectorAll(".staff-box a"),
    search: target.querySelector(".staff__search"),
    filter: target.querySelector(".staff__filter"),
    noResults: target.querySelector(".staff__no-results"),
  };

  let staffList = null;

  const method = {

    init: () => {
      el.links.forEach((link) => {
        link.addEventListener("mouseover", method.toggleHover);
        link.addEventListener("mouseout", method.toggleHover);
      });

      if (el.search) {
        el.search.addEventListener("keyup", method.search);

        staffList = new List(target, {
          valueNames: ["staff-box__name", "staff-box__company", "staff-box__position"],
          listClass: "staff__list",
        });
      }

      if (el.filter) {
        el.filter.addEventListener("change", method.filter);
      }
    },

    filter: (event) => {
      const filter = event.target.value;

      if (filter === window.dictionary.Staff_All) {
        staffList.filter();
      } else {
        staffList.filter(item => item.values()["staff-box__position"].match(filter));
      }

      method.toggleNoResults();
    },

    search: (event) => {
      if (event.target.value.length > 1) {
        staffList.search(event.target.value, ["staff-box__name", "staff-box__company"]);
      } else {
        staffList.search();
      }

      method.toggleNoResults();
    },

    toggleHover: (event) => {
      if (event.type === "mouseover") {
        event.target.parentElement.parentElement.classList.add("staff-box--hovered");
      } else if (event.type === "mouseout") {
        event.target.parentElement.parentElement.classList.remove("staff-box--hovered");
      }
    },

    toggleNoResults: () => {
      if (staffList.list.querySelectorAll(".staff-box").length > 0) {
        el.noResults.classList.remove("staff__no-results--visible");
      } else {
        el.noResults.classList.add("staff__no-results--visible");
      }
    },
  };

  method.init();
};

export default Staff;
